export default __webpack_public_path__ + "static/media/square.b73766b3.jpg";